export const GET_VEHICLES_LIST_PROVIDER_PRICE = 'GET_VEHICLES_LIST_PROVIDER_PRICE';
export const GET_VEHICLES_LIST_PROVIDER_PRICE_SUCCESS = 'GET_VEHICLES_LIST_PROVIDER_PRICE_SUCCESS';
export const GET_VEHICLES_LIST_PROVIDER_PRICE_ERROR = 'GET_VEHICLES_LIST_PROVIDER_PRICE_ERROR';

export const GET_VEHICLES_PROVIDER_PRICE_BY_ID = 'GET_VEHICLES_PROVIDER_PRICE_BY_ID';
export const GET_VEHICLES_PROVIDER_PRICE_BY_ID_SUCCESS = 'GET_VEHICLES_PROVIDER_PRICE_BY_ID_SUCCESS';
export const GET_VEHICLES_PROVIDER_PRICE_BY_ID_ERROR = 'GET_VEHICLES_PROVIDER_PRICE_BY_ID_ERROR';

export const DELETE_VEHICLE_PROVIDER_PRICE = 'DELETE_VEHICLE_PROVIDER_PRICE';
export const DELETE_VEHICLE_PROVIDER_PRICE_SUCCESS = 'DELETE_VEHICLE_PROVIDER_PRICE_SUCCESS';
export const DELETE_VEHICLE_PROVIDER_PRICE_ERROR = 'DELETE_VEHICLE_PROVIDER_PRICE_ERROR';

export const POST_VEHICLE_PROVIDER_PRICE = 'POST_VEHICLE_PROVIDER_PRICE';
export const POST_VEHICLE_PROVIDER_PRICE_SUCCESS = 'POST_VEHICLE_PROVIDER_PRICE_SUCCESS';
export const POST_VEHICLE_PROVIDER_PRICE_ERROR = 'POST_VEHICLE_PROVIDER_PRICE_ERROR';

export const GET_SUPPLIERS_LIST = 'GET_SUPPLIERS_LIST';
export const GET_SUPPLIERS_LIST_SUCCESS = 'GET_SUPPLIERS_LIST_SUCCESS';
export const GET_SUPPLIERS_LIST_ERROR = 'GET_SUPPLIERS_LIST_ERROR';

export const GET_PRICE_BY_PROVIDER = 'GET_PRICE_BY_PROVIDER';
export const GET_PRICE_BY_PROVIDER_SUCCESS = 'GET_PRICE_BY_PROVIDER_SUCCESS';
export const GET_PRICE_BY_PROVIDER_ERROR = 'GET_PRICE_BY_PROVIDER_ERROR';

export const GET_PRICE_XLS = 'GET_PRICE_XLS';
export const GET_PRICE_XLS_SUCCESS = 'GET_PRICE_XLS_SUCCESS';
export const GET_PRICE_XLS_ERROR = 'GET_PRICE_XLS_ERROR';

export const GET_COINCIDENCES = 'GET_COINCIDENCES';
export const GET_COINCIDENCES_SUCCESS = 'GET_COINCIDENCES_SUCCESS';
export const GET_COINCIDENCES_ERROR = 'GET_COINCIDENCES_ERROR';

export const GET_COINCIDENCES_XLS = 'GET_COINCIDENCES_XLS';
export const GET_COINCIDENCES_XLS_SUCCESS = 'GET_COINCIDENCES_XLS_SUCCESS';
export const GET_COINCIDENCES_XLS_ERROR = 'GET_COINCIDENCES_XLS_ERROR';